<template>
  <div>
    <div class="pb-3">
      <v-toolbar class="primary">
        <v-toolbar-title class="white--text">
          Additional Notes
        </v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <vonex-textarea
                  v-model="details.notes"
                  label="Input Additional Notes"
                  name="Notes"
                  dense
                  :options="fieldConditions"
                  @input="setDetails"
                  hide
                  :rows="8"
                  ></vonex-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div>
      <v-toolbar class="primary">
        <v-toolbar-title class="white--text">
          Channel Partner Details
        </v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>
              <v-flex xs12 sm4>
                <vonex-text
                  v-model="details.name"
                  label="Company Name"
                  name="Company Name"
                  dense
                  :options="fieldConditions"
                  @input="setDetails"
                ></vonex-text>
              </v-flex>
              <v-flex xs12 sm4>
                <vonex-text
                  v-model="details.email"
                  label="Email"
                  name="Email"
                  dense
                  :rule="'email'"
                  :options="fieldConditions"
                  @input="setDetails"
                ></vonex-text>
              </v-flex>
              <v-flex xs12 sm4>
                <vonex-text
                  v-model="details.phone"
                  label="Contact Number"
                  name="Contact Number"
                  dense
                  :rule="'contactNumber'"
                  :options="fieldConditions"
                  @input="setDetails"
                ></vonex-text>
              </v-flex>
              <!-- <v-flex xs12 sm3>
                <vonex-text
                  v-model="details.helpDesk"
                  label="Helpdesk Email"
                  name="Helpdesk Email"
                  dense
                  :rule="'email'"
                  :options="fieldConditions"
                  @input="setDetails"
                  ></vonex-text>
              </v-flex> -->
              <v-flex xs12 sm6>
                <vonex-textarea
                  v-model="details.bio"
                  label="Bio"
                  name="Bio"
                  dense
                  :options="fieldConditions"
                  @input="setDetails"
                ></vonex-textarea>
              </v-flex>
              <!-- <v-flex xs12 sm6>
                <vonex-textarea
                  v-model="details.notes"
                  label="Notes"
                  name="Notes"
                  dense
                  :options="fieldConditions"
                  @input="setDetails"
                  ></vonex-textarea>
              </v-flex> -->
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg12>
                <h3>Channel Partner Logo</h3>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 class="dropbox">
                <form enctype="multipart/form-data" novalidate>
                  <v-flex xs12 class="pt-3">
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      class="input-file"
                      @change="
                        filesChange($event.target.files);
                        fileCount = $event.target.files.length;
                      "
                    />
                  </v-flex>
                  <v-layout column align-center justify-center>
                    <v-flex xs12>
                      <span>
                        Drag your image file(s) here to begin upload or click to
                        browse
                        <br />
                        <p v-show="isSaving">
                          Uploading {{ fileCount }} files...
                          <v-progress-linear
                            :indeterminate="isSaving"
                          ></v-progress-linear>
                        </p>
                      </span>
                    </v-flex>
                    <v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="fileType"
                          label="File Type"
                          prepend-icon="cloud_upload"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 style="text-align: center">
                        <span>
                          Note: PNG file format are preferable for Channel Partner
                          Logo
                        </span>
                        <br />
                        <span>
                          Recommended Image Size:
                          <strong>500x300px</strong>
                        </span>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </form>
              </v-flex>
              <!-- <v-flex xs12 v-if="!details.img && !hasLogo">
                <span class="red--text text--lighten-1">Channel Partner Logo is Required.</span>
              </v-flex> -->
            </v-layout>

            <v-flex v-if="isDeleting" xs12>
              <span>Deleting</span>
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>

            <!--SUCCESS-->
            <v-flex v-if="isSuccess || rows.length > 0" xs12>
              <h2>Uploaded {{ rows.length }} file(s) successfully.</h2>
              <strong>Click a button below to download individual files.</strong>
              <v-data-table
                :headers="headers"
                :items="rows"
                class="elevation-1"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">
                    <v-btn
                      flat
                      icon
                      color="green"
                      @click="downloadAttachment(props.item)"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-left">
                    <b>{{ props.item.filename }}</b>
                  </td>
                  <td class="text-xs-left">{{ props.item.contentType }}</td>
                  <td class="text-xs-left">{{ props.item.fileType }}</td>
                  <td class="text-xs-left">
                    {{ props.item.fileSize | sizeToMB }}
                  </td>
                  <td class="text-xs-left">
                    <v-btn
                      v-if="!isDeleting"
                      flat
                      icon
                      color="red"
                      @click="removeAttachment(props.item.fileGuid)"
                    >
                      <v-icon>cancel</v-icon>
                      <v-progress-circular
                        v-show="isDeleting"
                        indeterminate
                        color="red"
                      ></v-progress-circular>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import ContractorDetail from '@/models/ContractorDetails';
import FileUploader from './../FileUploader';
import { mapActions, createNamespacedHelpers, mapGetters } from 'vuex';
import {
  mapUploadFields,
  mapUploadMultiRowFields,
} from '../../store/modules/orders';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapUploadActions } =
  createNamespacedHelpers(`orders/uploads`);
import { httpError } from '../../models/httpError';
import { bytesToSize } from '@/plugins/bytesToSize';

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: 'ContractorDetails',
  components: {
    FileUploader: FileUploader,
  },
  props: {
    quoteDetails: { type: Object, required: true },
    hasLogo: { type: Boolean, required: true },
  },
  data() {
    return {
      details: new ContractorDetail(),
      fileType: 'Image',
      files: new FormData(),
      fileCount: 0,
      headers: [
        {
          text: 'Download',
          align: 'left',
          sortable: false,
          value: 'true',
        },
        {
          text: 'File Name',
          align: 'left',
          sortable: true,
          value: 'filename',
        },
        {
          text: 'Content Type',
          align: 'left',
          sortable: true,
          value: 'contentType',
        },
        {
          text: 'File Type',
          align: 'left',
          sortable: true,
          value: 'fileType',
        },
        {
          text: 'File Size',
          align: 'left',
          sortable: true,
          value: 'fileSize',
        },
        {
          text: 'Remove',
          align: 'left',
          sortable: false,
          value: 'true',
        },
      ],
      isDeleting: false,
    };
  },
  mounted() {
    let vm = this;
    if (vm.quoteDetails.contractorDetails)
      vm.details = vm.quoteDetails.contractorDetails;
    else vm.details = new ContractorDetail();

    vm.populateUploads(vm.orderID);
    if (vm.rows.length > 0) vm.details.img = vm.rows[0].url;
    else vm.details.img = '';
    vm.setDetails();
  },
  computed: {
    ...mapUploadFields(['message']),
    ...mapUploadMultiRowFields(['rows']),
    ...mapGetters('orders', ['orderID']),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    totalFileSize() {
      return this.getTotalFileSize();
    },
  },
  methods: {
    ...mapUploadActions([
      'populateUploads',
      'updateUploadsOnOrder',
      'removeRows',
      'setMessage',
      'UploadToKayako',
      'getAttachment',
      'deleteAttachment',
      'getExtension',
      'populateUploadsCustomer',
    ]),
    setDetails() {
      this.$emit('contractorDetails', this.details);
    },
    filesChange(fileList) {
      // handle file changes
      let vm = this;
      let fileChangeSuccess = false;

      if (!fileList.length) return;
      const isUnSupported = (element) =>
        element.type !== 'image/jpeg' && element.type !== 'image/png';
      let files = Array.from(fileList);
      let someUnsupported = files.some(isUnSupported);
      if (someUnsupported)
        files = files.filter(
          (element) =>
            element.type === 'image/jpeg' || element.type === 'image/png'
        );

      this.fileCount = fileList.length;

      // append the files to FormData
      Array.from(Array(files.length).keys()).map((x) => {
        let fileSize = bytesToSize(files[x].size, 2, 1024, 'MiB');

        if (
          parseFloat(fileSize > this.maxAllowedFileSize) ||
          parseFloat(this.getTotalFileSize() - fileSize) < 0
        ) {
          vm.fileChangeSuccess = false;
          vm.uploadError =
            'Total size of all files exceeds order combined file size limit of 10MB';
          vm.currentStatus = STATUS_FAILED;
          return;
        }

        vm.files.append('files', files[x], files[x].name);
        vm.fileChangeSuccess = true;
      });

      // save it
      if (vm.fileChangeSuccess)
        this.save(someUnsupported, Array.from(fileList).filter(isUnSupported));
    },
    getTotalFileSize() {
      let size = this.rows.reduce(
        (acc, curr) => acc + bytesToSize(curr['fileSize'], 2, 1024, 'MiB'),
        0
      );
      return parseFloat(this.maxAllowedFileSize - size).toFixed(2);
    },
    save(someUnsupported, unsupportedFiles) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      let vm = this;
      let form = { guid: vm.orderGUID, data: vm.files, fileType: vm.fileType };

      if (someUnsupported && unsupportedFiles.length === 1) {
        vm.uploadError = 'These files are not of a supported type: ';
        vm.currentStatus = STATUS_FAILED;
        vm.unsupportedFiles = unsupportedFiles.map((s) => s.name);
      } else {
        vm.rows.forEach((row) => {
          vm.removeAttachment(row.fileGuid);
        });
        vm.$nextTick(() => {
          vm.updateUploadsOnOrder(form)
            .then((x) => {
              vm.uploadedFiles = [].concat(x.files);
              vm.details.img = vm.rows[0].url;

              if (someUnsupported) {
                vm.uploadError = 'These files are not of a supported type: ';
                vm.currentStatus = STATUS_FAILED;
                vm.unsupportedFiles = unsupportedFiles.map((s) => s.name);
              } else {
                vm.currentStatus = STATUS_SUCCESS;
                vm.currentStatus = STATUS_INITIAL;
              }
            })
            .catch((err) => {
              vm.uploadError = err.response;
              vm.currentStatus = STATUS_FAILED;
            });
        });
      }
      vm.files = new FormData();
      vm.setDetails();
    },
    removeAttachment(fileGuid) {
      let vm = this;
      // this.isDeleting = true;

      let filetoBeDeleted = { orderID: vm.orderID, guid: fileGuid };
      this.deleteAttachment(filetoBeDeleted)
        .then((x) => {
          // this.isDeleting = false;
          this.reset();
          this.populateUploads(vm.orderID);
          vm.details.img = '';
          vm.setDetails();
        })
        .catch((err) => {
          vm.uploadError = err.response;
        });
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.files = new FormData();
      this.fileCount = 0;
    },
  },
  filters: {
    sizeToMB(args) {
      return `${bytesToSize(args, 2, 1024, 'MiB')} MB`;
    },
  },
};
</script>
<style scoped lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.dropbox-error {
  outline: 2px dashed white; /* the dash box */
  outline-offset: -10px;
  background: #b71c1c;
  color: white;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
